module.exports = __webpack_public_path__ + "img/BlueGrayBottom.c1549665.jpg";